import { useState } from "react";
import { BsPlus } from "react-icons/bs";
import { MdOutlineDragIndicator } from "react-icons/md";
import { Container, Draggable } from "react-smooth-dnd";
import formFields from "../../../utils/db/formFields";

const FormFieldsList = ({ translate, setIsModalOpen }) => {
  const [containerProps] = useState({
    dragHandleSelector: ".form-field-item[data-is-draggable=true]",
    dragClass: "cursor--grabbing",
    behaviour: "copy",
  });

  return (
    <div className="FormFieldsList d-flex flex-column align-items-center w-100">
      <div className="form-field-group w-100">
        <Container
          {...containerProps}
          groupName="top-group"
          getChildPayload={() => ({
            fieldType: "repeatable",
            source: "sidebar",
          })}
        >
          <Draggable>
            <div
              className="form-field-item subform w-100 d-flex justify-content-between align-items-center"
              role="button"
              data-is-draggable="false"
              onClick={() => setIsModalOpen(true)}
            >
              <div className="left-side d-flex justify-content-start align-items-center">
                <span className="text text-uppercase">
                  {translate("form_fields.sub_form")}
                </span>
              </div>
              <div className="right-side d-flex justify-content-start align-items-center">
                <span className="icon">
                  <BsPlus />
                </span>
              </div>
            </div>
          </Draggable>
          <Draggable>
            <div
              className="form-field-item repeatable w-100 d-flex justify-content-start align-items-center"
              data-is-draggable="true"
            >
              <span className="drag-trigger cursor--grab">
                <MdOutlineDragIndicator size={20} />
              </span>
              <span className="text text-uppercase">
                {translate("form_fields.repeatable")}
              </span>
            </div>
          </Draggable>
        </Container>
      </div>
      {formFields
        .sort((a, b) => a.order - b.order)
        .map((form, i) => {
          const fields = form.fields
            .sort((a, b) => a.order - b.order)
            .map((field) => (
              <Draggable key={field.fieldType}>
                <div
                  className="form-field-item w-100 d-flex justify-content-start align-items-center cursor--grab"
                  data-is-draggable="true"
                >
                  <span className="drag-icon">
                    <MdOutlineDragIndicator size={20} />
                  </span>
                  <span className="text text-uppercase">
                    {translate(
                      `form_fields.uppercase_translates.${field.fieldType}`
                    )}
                  </span>
                </div>
              </Draggable>
            ));

          return (
            <div key={i} className="form-field-group w-100">
              <Container
                {...containerProps}
                groupName={`group-${i}`}
                getChildPayload={(child) => ({
                  ...formFields[i].fields[child],
                  source: "sidebar",
                })}
              >
                {fields}
              </Container>
            </div>
          );
        })}
    </div>
  );
};

export default FormFieldsList;
